import { UserRole } from '@grcs/types/UserRole';
import { ProtectedRoute, ProtectedRouteProps } from './ProtectedRoute';

export const TeacherProtectedRoute: React.FC<
  Pick<ProtectedRouteProps, 'children'>
> = ({ children }) => {
  return <ProtectedRoute access={UserRole.TEACHER}>{children}</ProtectedRoute>;
};
